import { render, staticRenderFns } from "./ShippingPageCms.vue?vue&type=template&id=4e1de58a&scoped=true"
import script from "./ShippingPageCms.vue?vue&type=script&lang=js"
export * from "./ShippingPageCms.vue?vue&type=script&lang=js"
import style0 from "./ShippingPageCms.vue?vue&type=style&index=0&id=4e1de58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1de58a",
  null
  
)

export default component.exports